import React from 'react';
import styled from 'styled-components';
import NavLink from './nav-link';
import SubNavLink from './sub-nav-link';
import activeClassName from './active-classname';
import HasChildrenIcon from './has-children-icon';
import SubItemsWrapper from './sub-items-wrapper';

const NavItem = ({ label, url, subItems = [] }) => (
  <Li>
    <NavLink
      to={url}
      activeClassName={activeClassName}
      partiallyActive
      $hasChildren={subItems.length > 0}
    >
      {label}
      {subItems.length > 0 && (
        <HasChildrenIcon />
      )}
    </NavLink>
    {subItems.length > 0 && (
      <SubItemsWrapper>
        {subItems.map((item) => (
          <Li key={item.url}>
            <SubNavLink
              partiallyActive
              activeClassName={activeClassName}
              to={item.url}
            >
              {item.label}
            </SubNavLink>
          </Li>
        ))}
      </SubItemsWrapper>
    )}
  </Li>
);

const Li = styled.li`
  list-style: none;
  position: relative;
  &:hover {
    ${SubItemsWrapper} {
      display: flex;
    };
  }
`;

export default NavItem;
